// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CompaneysCrousel_main {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%; /* Ensure it takes full width */
  
}

.CompaneysCrousel {
  width: 100%;
  padding: 20px 0;
  background: #ffffff !important;
  /* display: flex; */
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 30px auto; /* Adjusted for automatic horizontal margin */
}




.slider_heading {
  text-align: center;
  align-items: center;
  margin-top: 87px;
  color: #656565;
  font-size: 84px;
  font-weight: 400;
  margin-bottom: 50px !important; 
}

.slider_heading_main_trust {
  margin: 35px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  text-align: center;
}

.slider_heading_trust{
font-size: 16px;
text-align: center;
align-items: center;
font-family: inter;
font-weight: 400;
line-height: 26px;
text-align: center;

}

.slider_down_div{
  margin-top: 87px;
}

.slider_main_parent {
  width: 80%; /* Adjust the width of the slider */
  margin: 0 auto; /* Center the slider horizontally */
}

.slider_img img {
  width: auto; /* Allow the browser to set width */
  max-width: 50%; /* Reduce max width to make images smaller */
  height: auto; /* Maintain aspect ratio */
  display: block; /* Removes extra space below images */
  margin: 0 auto; /* Centers images horizontally */
}



/* You may also want to change the arrow button background or borders, example: */



@media (max-width: 1024px) {
  .slider_main_parent {
      width: 90%; /* Larger percentage for smaller screens */
  }
}

@media (max-width: 768px) {
  .slider_heading_trust{
    font-family: Inter;
font-size: 14px;
font-weight: 400;
line-height: 24px;
text-align: center;

  }
  .slider_img img {
      max-width: 75%;
      align-items: center;
      vertical-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/TrustedCompaneys/Companeycrousel.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW,EAAE,+BAA+B;;AAE9C;;AAEA;EACE,WAAW;EACX,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB,EAAE,6CAA6C;AAClE;;;;;AAKA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;AACA,eAAe;AACf,kBAAkB;AAClB,mBAAmB;AACnB,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB;AACjB,kBAAkB;;AAElB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU,EAAE,mCAAmC;EAC/C,cAAc,EAAE,mCAAmC;AACrD;;AAEA;EACE,WAAW,EAAE,mCAAmC;EAChD,cAAc,EAAE,4CAA4C;EAC5D,YAAY,EAAE,0BAA0B;EACxC,cAAc,EAAE,qCAAqC;EACrD,cAAc,EAAE,gCAAgC;AAClD;;;;AAIA,iFAAiF;;;;AAIjF;EACE;MACI,UAAU,EAAE,0CAA0C;EAC1D;AACF;;AAEA;EACE;IACE,kBAAkB;AACtB,eAAe;AACf,gBAAgB;AAChB,iBAAiB;AACjB,kBAAkB;;EAEhB;EACA;MACI,cAAc;MACd,mBAAmB;MACnB,sBAAsB;EAC1B;AACF","sourcesContent":[".CompaneysCrousel_main {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%; /* Ensure it takes full width */\n  \n}\n\n.CompaneysCrousel {\n  width: 100%;\n  padding: 20px 0;\n  background: #ffffff !important;\n  /* display: flex; */\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin: 30px auto; /* Adjusted for automatic horizontal margin */\n}\n\n\n\n\n.slider_heading {\n  text-align: center;\n  align-items: center;\n  margin-top: 87px;\n  color: #656565;\n  font-size: 84px;\n  font-weight: 400;\n  margin-bottom: 50px !important; \n}\n\n.slider_heading_main_trust {\n  margin: 35px 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  text-align: center;\n}\n\n.slider_heading_trust{\nfont-size: 16px;\ntext-align: center;\nalign-items: center;\nfont-family: inter;\nfont-weight: 400;\nline-height: 26px;\ntext-align: center;\n\n}\n\n.slider_down_div{\n  margin-top: 87px;\n}\n\n.slider_main_parent {\n  width: 80%; /* Adjust the width of the slider */\n  margin: 0 auto; /* Center the slider horizontally */\n}\n\n.slider_img img {\n  width: auto; /* Allow the browser to set width */\n  max-width: 50%; /* Reduce max width to make images smaller */\n  height: auto; /* Maintain aspect ratio */\n  display: block; /* Removes extra space below images */\n  margin: 0 auto; /* Centers images horizontally */\n}\n\n\n\n/* You may also want to change the arrow button background or borders, example: */\n\n\n\n@media (max-width: 1024px) {\n  .slider_main_parent {\n      width: 90%; /* Larger percentage for smaller screens */\n  }\n}\n\n@media (max-width: 768px) {\n  .slider_heading_trust{\n    font-family: Inter;\nfont-size: 14px;\nfont-weight: 400;\nline-height: 24px;\ntext-align: center;\n\n  }\n  .slider_img img {\n      max-width: 75%;\n      align-items: center;\n      vertical-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
